const OPERATION_MESSAGES = {
  TRY_AGAIN_LATER: 'Por favor, tente novamente mais tarde',
}

OPERATION_MESSAGES.RECORD_REMOVE_SUCCESS = 'Registro removido com sucesso'
OPERATION_MESSAGES.RECORD_REMOVE_FAIL = `Falha ao remover registro. ${OPERATION_MESSAGES.TRY_AGAIN_LATER}`

OPERATION_MESSAGES.RECORD_UPDATE_SUCCESS = 'Registro atualizado com sucesso'
OPERATION_MESSAGES.RECORD_UPDATE_FAIL = `Falha na atualização do registro. ${OPERATION_MESSAGES.TRY_AGAIN_LATER}`

OPERATION_MESSAGES.RECORD_ADD_SUCCESS = 'Registro criado com sucesso'
OPERATION_MESSAGES.RECORD_ADD_FAIL = `Falha na criação do registro. ${OPERATION_MESSAGES.TRY_AGAIN_LATER}`

OPERATION_MESSAGES.LOAD_DATA_FAIL = 'Falha ao carregar dados'

OPERATION_MESSAGES.PERMANENT_ACTION_CONFIRMATION = 'Essa operação tem caráter permanente e não poderá ser ' +
  'revertida. Tem certeza que deseja continuar?'

OPERATION_MESSAGES.CHECK_INFORMED_DATA = 'Verifique os dados informados e tente novamente'

export { OPERATION_MESSAGES }
